<template>
	<div class="masters">
		<div class="masters__controls">
            <tab
				:active="isActive"
				@changeView="changeView"
				:options="['list', 'map']"
            />

			<template
				v-if="isActive === 'list'"
			>
        <Select2
					:options="services"
					:settings="selectSetting"
					class="select"
					@select="selectEngineer($event)"
				/>

				<div v-if="partners.length !== 0">
					<Select2
						v-model="params.partnerId"
						:options="partners"
						:settings="{
							placeholder: $t('navigation.partners'),
							allowClear: false
						}"
						class="select"
						@select="selectPartner($event)"
					/>
				</div>

				<search
					@searchData='searchEngineer'
					:value="search"
				/>

			</template>

			<template
				v-if="isActive === 'map'"
			>
				<Select2
					:settings="{
						placeholder: 'Choose master',
						allowClear: false
					}"
					:options="mastersToSelect"
					@select="openMasterMap($event)"
				/>

				<Select2
					:options="services"
					:settings="selectSetting"
					class="select"
					@select="selectMapServices($event)"
				/>

				<datetime
					class="day-datepicker"
					:class="{
						'day-datepicker_inactive': '' === '',
						'disabled-datepicker': mapViewGetters === 'all'
					}"
					input-class="date-input"
					:placeholder="$t('request.dateHolder')"
					@input="setMapDay($event)"
					:disabled="mapViewGetters === 'all'"
				/>
			</template>
        </div>

		<div class="masters__content">
      <transition name="fade">
      <specialist-list
				:type="'engineers'"
				:isActive="isActive"
      />
			</transition>
		</div>
	</div>
</template>

<script>
import store from '@/store'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import specialistList from '@/components/lists/specialist/specialistList'

const type = 'engineers'
export default {
    components: {
        specialistList,
    },
    data() {
        return {
            type,
            isActive: 'list',
            selectSetting: {
                placeholder: this.$t('navigation.services'),
                allowClear: false,
            },
            request: '',
            mastersToSelect: [],
            partners: [],
        }
    },
    computed: {
        ...mapGetters({
            services: 'servicesGetters',
            search: 'specialists/searchGetters',
            mapViewGetters: 'mapViewGetters',
            partnersGetters: 'partners/partnersGetters',
            partnersSetting: 'specialists/partnersSettingGetters',
            params: 'specialists/paramsGetters',
        }),
        masters() {
            return this.$store.state.specialists.data
        },
    },
    async beforeRouteEnter(to, from, next) {
        await store.dispatch('specialists/getSpecialistsData', { type })
        next()
    },
    beforeRouteLeave(to, from, next) {
        this.setOrderMapWindow(false)
        this.setMapDate(null)
        next()
    },
    methods: {
        ...mapMutations({
            setSearch: 'specialists/setSearch',
            setSelectData: 'specialists/setSelectData',

            setMapDate: 'setMapDate',
            setMapService: 'setMapService',
            setOrderMapWindow: 'setOrderMapWindow',
        }),
        ...mapActions({
            getMadDataById: 'getMadDataById',
            fetchMap: 'fetchMap',
            fetchPartners: 'partners/fetch',
        }),
        changeView(view) {
            if (view === 'list') {
                this.setMapDate(null)
                this.setOrderMapWindow(false)
            }

            this.isActive = view
        },
        searchEngineer(data) {
            this.setSearch(data)
        },
        selectEngineer({ id }) {
            if (id === 'all') {
                this.setSelectData('')
                return
            }

            if (this.selectData !== id) {
                this.setSelectData(id)
            } else {
                this.setSelectData('')
            }
        },

        openMasterMap(e) {
            this.getMadDataById({ id: e.id, type: 'engineers' })
        },
        selectMapServices(id) {
            this.setMapService(id)
        },
        setMapDay(e) {
            if (e !== '') {
                this.setMapDate(e)
                this.fetchMap({ type: 'engineers' })
            }
        },
        async selectPartner() {
            await this.$store.dispatch('specialists/getSpecialistsData', { type })
        },
        prepareMastersToSelect() {
            if (this.mastersToSelect.length === 0) {
                return
            }

            if (this.mastersToSelect[0].id !== 'all') {
                this.mastersToSelect.unshift({
                    text: this.$t('listsHeader.all'),
                    id: 'all',
                })
            }
        },
        prepareMaster() {
            this.masters.forEach((e) => {
                this.mastersToSelect.push({
                    id: e.id,
                    text: `${e.first_name} ${e.last_name}`,
                })
            })
        },
        preparePartners() {
            this.partnersGetters.forEach((element) => {
                this.partners.push({
                    id: element.id,
                    text: element.name,
                    is_active: undefined,
                })
            })

            if (this.partners.length === 0) {
                return
            }

            if (this.partners[0].id !== 'all') {
                this.partners.unshift({
                    text: this.$t('listsHeader.all'),
                    id: 'all',
                })
            }
        },
    },
    beforeMount() {
        this.prepareMaster()
        this.prepareMastersToSelect()
    },
    async mounted() {
        await this.fetchPartners({})
        this.preparePartners()
    },
}
</script>
<style lang="scss" scoped>
@import 'src/assets/sass/main';
.masters {
	width: 100%;
	height: 100%;
	padding: 36px 60px 60px 60px;
	box-sizing: border-box;
	position: absolute;
	left: 0;
	top: 0;

	&__controls {
		margin-bottom: 36px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	& .select {
		max-width: 240px;
	}
	&__content {
		position: relative;
		height: 100%;
	}
}

.day-datepicker {
	width: 300px;
	height: 45px;
    padding-left: 10px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 8px;
    position: relative;
	background-color: #fff;
}

.day-datepicker_inactive::after {
    position: absolute;
    right: 20px;
    top: 30%;
    content: '';
    background-image: url(/images/calendar.png);
    width: 20px;
    height: 20px;
    z-index: 3;
}
</style>

<style>
.day-datepicker .date-input {
	height: 90% !important;
}

body .disabled-datepicker {
	cursor: not-allowed !important;
}

.disabled-datepicker .date-input {
	cursor: not-allowed !important;
}
</style>
